<span class="info-block header-signin" i18n>
  <a routerLink="/join">Register</a> or <a routerLink="/login">Sign In</a>
</span>
